module.exports = __webpack_public_path__ + "static/media/stripe.0042db18.png";